import { useState } from 'react';
import axios from 'axios';

const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;
const SUCCESS_RESET_MS = 4000;

const INITIAL_FORM = {
  name: '',
  email: '',
  phone: '',
  message: '',
};

export const useContactForm = () => {
  const [formData, setFormData] = useState(INITIAL_FORM);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [formError, setFormError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleInputChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormError('');
    setSubmitting(true);
    try {
      await axios.post(`${API_BASE}/contact`, {
        name: formData.name,
        email: formData.email,
        phone: formData.phone || null,
        message: formData.message,
      });
      setFormSubmitted(true);
      setTimeout(() => {
        setFormSubmitted(false);
        setFormData(INITIAL_FORM);
      }, SUCCESS_RESET_MS);
    } catch (err) {
      const detail = err?.response?.data?.detail;
      const msg = typeof detail === 'string'
        ? detail
        : 'Something went wrong. Please check your inputs and try again.';
      setFormError(msg);
    } finally {
      setSubmitting(false);
    }
  };

  return {
    formData,
    formSubmitted,
    formError,
    submitting,
    handleInputChange,
    handleSubmit,
  };
};
